const sysNotice = {
  state: {
    uploadTypeKey: '',
    uploadFilesData: {},
    uploadFilesArr: []
  },

  mutations: {
    SYSNOTICE_UPLOAD_TYPE(state, data) {
      state.uploadTypeKey = data;
    },
    SET_SYS_UPLOAD_FILES_DATA(state, data) {
      state.uploadFilesData = data;
    },
    SET_SYS_UPLOAD_FILES_ARR(state, data) {
      state.uploadFilesArr = data;
    }
  },
  actions: {
    sysNoticeUploadType ({ commit }, data) {
      commit('SYSNOTICE_UPLOAD_TYPE', data);
    },
    setSysUploadFilesData({ commit }, data) {
      commit('SET_SYS_UPLOAD_FILES_DATA', data);
    },
    setSysUploadFilesArr({ commit }, data) {
      commit('SET_SYS_UPLOAD_FILES_ARR', data);
    }
  }
};
export default sysNotice;
